import { Component, OnInit } from '@angular/core';
import { HttpCacheService } from 'src/app/services//http-cache.service';
import { COMMON_CONSTANTS } from '../core/common.constants';
import {OktaAuthorizationService} from 'src/app/services/okta-auth-service';
import {RESTRICTEDPAGE } from '../core/common.constants';
import * as _ from 'lodash';

@Component({
  selector: 'app-restrict-page',
  templateUrl: './restrict-page.component.html',
  styleUrls: ['./restrict-page.component.scss']
})

export class RestrictPageComponent implements OnInit {
  public authoringContentData: any =  RESTRICTEDPAGE;
  public enableLoginButton = false;
  constructor(
    private _cacheSvc: HttpCacheService,
    public oktaAuthService: OktaAuthorizationService
    ) {}

  ngOnInit() {
    this.oktaAuthService.restrictAccess.next(true);
    const accessToken = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.OKTA_ID_TOKEN);
    if (!_.isNull(accessToken) && !_.isUndefined(accessToken)) {
      this.enableLoginButton = true;
    }
  }
  backTologin() {
    this.oktaAuthService.logOutFromOkta();
   }
}
